/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';

import { useBreakpoint } from '~/techstyle-shared/react-components';

import DesktopGridLayout from './components/DesktopGridLayout';
import MobileGridLayout from './components/MobileGridLayout';
import { BuilderConstructorGridInputProvider } from './hooks/useBuilderConstructorGridInputs';
import { ProductGridDataProvider } from './hooks/useProductGridData';

const BuilderConstructorGridV1_1 = ({
  assetContainer,
  builderState,
  categoryIdOverride,
  categorySelection,
  collectionIdOverride,
  collectionSelection,
  facet,
  facetOption,
  filterType,
  gridGender,
  gridHeader,
  gridStyleGuide,
  productSource,
  sideNav,
  sortOptions,
}) => {
  const { isMobile } = useBreakpoint();

  // This is to prevent content shift between SSR and CSR hydration
  if (typeof window === 'undefined') {
    return null;
  }

  return (
    <BuilderConstructorGridInputProvider
      value={{
        assetContainer,
        builderState,
        builderModel: builderState?.state?.modelName,
        categoryIdOverride,
        categorySelection,
        collectionIdOverride,
        collectionSelection,
        facet,
        facetOption,
        filterType,
        gridGender,
        gridHeader,
        gridStyleGuide,
        productSource,
        sideNav,
        sortOptions,
      }}
    >
      <ProductGridDataProvider>
        {isMobile ? <MobileGridLayout /> : <DesktopGridLayout />}
      </ProductGridDataProvider>
    </BuilderConstructorGridInputProvider>
  );
};

BuilderConstructorGridV1_1.propTypes = {
  assetContainer: PropTypes.shape({
    gridAssetContainer: PropTypes.string,
    gridAssetContainerMobile: PropTypes.string,
  }),
  builderState: PropTypes.object,
  categoryIdOverride: PropTypes.string,
  categorySelection: PropTypes.shape({
    value: PropTypes.string,
  }),
  collectionIdOverride: PropTypes.string,
  collectionSelection: PropTypes.shape({
    value: PropTypes.string,
  }),
  facet: PropTypes.string,
  facetOption: PropTypes.string,
  filterType: PropTypes.string,
  gridGender: PropTypes.string,
  gridHeader: PropTypes.string,
  gridStyleGuide: PropTypes.shape({
    tagList: PropTypes.string,
    assetContainers: PropTypes.shape({
      desktop: PropTypes.string,
      mobile: PropTypes.string,
      marketingCard: PropTypes.string,
    }),
  }),
  productSource: PropTypes.string,
  sideNav: PropTypes.shape({
    shouldShowCategoryNav: PropTypes.bool,
    shouldShowCategoryHeading: PropTypes.bool,
    categoryNavContainer: PropTypes.string,
  }),
  sortOptions: PropTypes.array,
};

export default BuilderConstructorGridV1_1;
